export const API_CCM_AGENT_DASHBOARD = 'reports/reports/ccm-agent-dashboard';
export const API_CCM_AGENT_DASHBOARD_COUNT =
  'reports/reports/ccm-agent-dashboard-count';
